import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Button} from 'views/components';

import {ChevronRight} from 'views/icons';

import {Translate} from 'views/module';


const CaregiverDescription = (props) => {
  const setOpenDrawerView = props.setOpenDrawerView;
  const showSettings = props.showSettings;

  if (showSettings) {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          py: 1,
          px: {md: 2, xs: 1},
          borderBlock: '1px solid #E0E0E0',
        }}
      >
        <Typography sx={{textTransform: 'uppercase', fontWeight: 500}}>
          <Translate expression='caregiver.CaregiverDetail.Settings.SettingsDescription'/>
        </Typography>
        <Button
          startIcon={<ChevronRight />}
          variant='outlined'
          onClick={() => setOpenDrawerView(true)}
          data-testid='settingsDrawerView'
        >
          <Typography sx={{fontSize: '16px', textTransform: 'uppercase', fontWeight: 500}}>
            <Translate expression='generic.View'/>
          </Typography>
        </Button>
      </Stack>
    );
  } else {
    return null;
  }
};
CaregiverDescription.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  showSettings: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

export default React.memo(CaregiverDescription);
